import axios from './axios';
import { saveAndOpenFile } from '../utils/fileUtils';

const API_URL = '/api/v1/maintenance';

export const getDashboardStats = async () => {
    return await axios.get(`${API_URL}/dashboard`);
};

export const getUnitTypes = async () => {
    return await axios.get(`${API_URL}/unit-types`);
};

export const storeUnitType = async (type) => {
    return await axios.post(`${API_URL}/unit-types`, { unit_type: type });
};

export const deleteUnitType = async (type) => {
    return await axios.delete(`${API_URL}/unit-types`, { data: { unit_type: type } });
};

export const getUnits = async (page = 1, status = 'All', search = '', fy = '', block = '') => {
    return await axios.get(`${API_URL}/units`, { params: { page, status, search, fy, block } });
};

export const createUnit = async (data) => {
    return await axios.post(`${API_URL}/units`, data);
};

export const getUnitDetails = async (id) => {
    return await axios.get(`${API_URL}/units/${id}`);
};

export const updateUnit = async (id, data) => {
    return await axios.put(`${API_URL}/units/${id}`, data);
};

export const deleteUnit = async (id) => {
    return await axios.delete(`${API_URL}/units/${id}`);
};

export const importUnits = async (data) => {
    return await axios.post(`${API_URL}/units/import`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const downloadImportTemplate = async () => {
    try {
        const response = await axios.get(`${API_URL}/units/import-template`, {
            responseType: 'blob'
        });
        
        const blob = new Blob([response]);
        await saveAndOpenFile(blob, 'units_import_template.csv');
    } catch (error) {
        console.error("Failed to download template:", error);
        throw error;
    }
};

export const generateBills = async (data) => {
    return await axios.post(`${API_URL}/generate-bills`, data);
};

export const recordPayment = async (unitId, data) => {
    return await axios.post(`${API_URL}/units/${unitId}/payments`, data);
};

export const getReceipt = async (receiptId) => {
    return await axios.get(`${API_URL}/receipts/${receiptId}`);
};

export const downloadReceiptPdf = async (receiptId, receiptNumber) => {
    try {
        const response = await axios.get(`${API_URL}/payments/${receiptId}/receipt?download=1`, {
            responseType: 'blob'
        });
        
        const blob = response instanceof Blob ? response : new Blob([response], { type: 'application/pdf' });
        const safeReceiptNo = (receiptNumber || receiptId || 'receipt').toString().replace(/\//g, '-');
        const name = `receipt-${safeReceiptNo}.pdf`;
        await saveAndOpenFile(blob, name);
    } catch (error) {
        console.error("Failed to download receipt:", error);
        throw error;
    }
};

export const downloadStatementPdf = async (unitId, fy, unitNumber) => {
    try {
        const response = await axios.get(`${API_URL}/units/${unitId}/statement?fy=${fy}`, {
            responseType: 'blob'
        });
        
        const blob = response instanceof Blob ? response : new Blob([response], { type: 'application/pdf' });
        const name = `statement-${unitNumber}-${fy}.pdf`;
        await saveAndOpenFile(blob, name);
    } catch (error) {
        console.error("Failed to download statement:", error);
        throw error;
    }
};

export const getYearlySummary = async (fy) => {
    return await axios.get(`${API_URL}/yearly-summary`, { params: { fy } });
};

export const sendReminders = async (unitIds = [], block = '') => {
    return await axios.post(`${API_URL}/send-reminders`, { unit_ids: unitIds, block });
};

export const exportData = async (fy, format = 'csv') => {
    try {
        const response = await axios.get(`${API_URL}/export`, {
            params: { fy, format },
            responseType: 'blob'
        });
        
        const blob = response instanceof Blob ? response : new Blob([response]);
        const name = `maintenance-${fy}.${format}`;
        await saveAndOpenFile(blob, name);
    } catch (error) {
        console.error("Failed to export maintenance data:", error);
        throw error;
    }
};

// --- New Invoice System APIs ---

export const getInvoicesDashboard = async () => {
    return await axios.get(`${API_URL}/invoices/dashboard`);
};
export const getInvoiceDashboard = getInvoicesDashboard;

export const getUnitInvoices = async (unitId) => {
    return await axios.get(`${API_URL}/units/${unitId}/invoices`);
};

export const storeCustomInvoice = async (unitId, data) => {
    return await axios.post(`${API_URL}/units/${unitId}/custom-invoice`, data);
};

export const settleDues = async (unitId, data) => {
    return await axios.post(`${API_URL}/units/${unitId}/settle`, data);
};

export const getUnitLedger = async (unitId) => {
    return await axios.get(`${API_URL}/units/${unitId}/ledger`);
};

export const reversePayment = async (paymentId) => {
    return await axios.delete(`${API_URL}/payments/${paymentId}`);
};

export const waivePenalty = async (invoiceId) => {
    return await axios.post(`${API_URL}/invoices/${invoiceId}/waive-penalty`);
};

export const downloadInvoicePdf = async (invoiceId, invoiceNumber) => {
    try {
        const response = await axios.get(`${API_URL}/invoices/${invoiceId}/download`, {
            responseType: 'blob'
        });
        
        const blob = response instanceof Blob ? response : new Blob([response], { type: 'application/pdf' });
        const name = `Invoice_${invoiceNumber || invoiceId}.pdf`;
        await saveAndOpenFile(blob, name);
    } catch (error) {
        console.error("Failed to download invoice:", error);
        throw error;
    }
};
